import { useParams } from "react-router-dom";
import { Col, Row } from "reactstrap";
import ProductByIdContainer from "../../Componant/organisms/ProductById";
import { useProductRequest } from "../../hooks/useProductRequest";

function ProductById() {
  const { productId } = useParams<{ productId: string }>();
  const { error, request } = useProductRequest();
  const service = request.find((service) => service.id === productId);

  if (!productId || service === undefined || error)
    return (
      <Row>
        <Col className="d-flex justify-content-center">
          {error ? error : "User Id Not Found"}
        </Col>
      </Row>
    );
  return (
    <div className="page-body">
      <ProductByIdContainer product={service} />
    </div>
  );
}

export default ProductById;
